import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {ToastrService} from 'toastr-ng2';
import {PushNotificationService} from './push-notification.service';
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.scss'],
  providers:[PushNotificationService]
})
export class PushNotificationComponent {
notification:any={}

message:any = {
        //app_id: "614240e3-c369-44a1-82fb-73227bd2c71c",
        app_id:"7016cbaa-2147-4b57-baaa-8c9bac9800f1",
        contents: {"en": ''},
        headings:{"en":''},
        included_segments: ["All"]
    };

  constructor(public router:Router,public pushNotification:PushNotificationService,public toster: ToastrService) { }


onpushNotification(form:NgForm){
//console.log("notification"+JSON.stringify(this.message));
this.pushNotification.sendNotification(this.message).subscribe(res=>{
	this.toster.success('Notification Send Successfully!', 'Success!');
  })  

}

cancel(){
       this.router.navigate(['/coupons/all']);

}


}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/push-notification/push-notification.component.ts